import Resource, {BaseResource} from './Resource';

/**
 * Lead Resource
 */
class Lead extends Resource
{
    constructor() {
        super('lead', ['leads']);
    }

    pathways(id) {
        return this._doGet([id, 'pathways'])
    }

    won(id, data) {
        return this._doPut([id, 'won'], data);
    }

    lost(id, data) {
        return this._doPut([id, 'lost'], data);
    }

    rollback(id, data) {
        return this._doPut([id, 'rollback'], data);
    }

    convert(id, conversion_detail_id) {
        return this._doPost([id, 'convert'], { conversion_detail_id });
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}   

export let LeadResource = new Lead();

class LeadDetail extends BaseResource
{
    show(id) {
        return this._doGet(['leads', id, 'detail'])
    }

    update(id, detail) {
        return this._doPost(['leads', id, 'detail'], detail)
    }
}

export let LeadDetailResource = new LeadDetail()

export let LeadSchema = function(defaults = {}) {
    let schema = {
        type: null,
        title: null,
        referral_source_id: null,
        contact_id: null,
        created_by_id: null,
        owner_id: null,
        location_id: null,
        stage_id: null,
        concern: null,
        converted_to: null,
        outcome: null,
        outcome_notes: null,
        outcome_at: null,
        detail: []
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let LeadDetailSchema = function(defaults = {}) {
    let schema = {
        lead_id: null,
        detail_type: null,
        detail_id: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export const LeadTypes = {
    SALES: 'sales',
    BUYING: 'buying',
    //SOURCING: 'sourcing',
    //RETARGETING: 'retargeting',
}

export const LeadTypesList = [
    { id: LeadTypes.SALES, label: 'Sales Lead' },
    { id: LeadTypes.BUYING, label: 'Buying Lead' },
    //{ id: LeadTypes.SOURCING, label: 'Sourcing Lead' },
    //{ id: LeadTypes.RETARGETING, label: 'Retargeting Lead' },
]

export const LeadDetailTypes = {
    VEHICLE_OF_INTEREST: 'vehicle_of_interest',
    VEHICLE_OFFERED: 'vehicle_offered',
}

export const LeadStatuses = {
    ACTIVE: 'active',
    CLOSING: 'closing',
    WON: 'won',
    LOST: 'lost',
}